import httpService from "app/services/httpService";
import config from "../../../src/config.json";

const apiUrl = config.apiUrl;

const getMenu = async () => {
  const { data } = await httpService.get(`${apiUrl}/authenticate/menu`);
  return data;
};

const addMenu = async (parentId, values) => {
  try {
    const url = `${apiUrl}/authenticate/menu/${parentId}/child`;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};

const editMenu = async (parentId, values) => {
  try {
    const url = `${apiUrl}/authenticate/menu/edit/${parentId}`;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};

const addParentMenu = async (values) => {
  try {
    const url = `${apiUrl}/authenticate/menu/parent`;
    const { data } = await httpService.post(url, values);
    return data;
  } catch (error) {
    throw error;
  }
};

const deleteMenu = async (id) => {
  try {
    const url = `${apiUrl}/authenticate/menu/delete/${id}`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const orderUpMenu = async (id) => {
  try {
    const url = `${apiUrl}/authenticate/menu/${id}/order/up`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const orderDownMenu = async (id) => {
  try {
    const url = `${apiUrl}/authenticate/menu/${id}/order/down`;
    const { data } = await httpService.post(url);
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  getMenu,
  addMenu,
  editMenu,
  addParentMenu,
  deleteMenu,
  orderUpMenu,
  orderDownMenu,
};
